(function () {
  var LAYOUTS = {
    option_1: {
      frames: [
        { id: 'a', w: 11, h: 14, x: 0, y: 1.5, label: '11×14' },
        { id: 'b', w: 8, h: 8, x: 12, y: 0, label: '8×8' },
        { id: 'c', w: 12, h: 8, x: 12, y: 9, label: '12×8' }
      ],
      bounds: { w: 24, h: 17 }
    },
    option_2: {
      frames: [
        { id: 'a', w: 10, h: 10, x: 0, y: 0, label: '10×10' },
        { id: 'b', w: 14, h: 11, x: 0, y: 11, label: '14×11' },
        { id: 'c', w: 20, h: 16, x: 15, y: 3, label: '20×16' }
      ],
      bounds: { w: 35, h: 22 }
    },
    option_3: {
      frames: [
        { id: 'a', w: 8, h: 8, x: 0, y: 1.5, label: '8×8' },
        { id: 'b', w: 8, h: 8, x: 0, y: 10.5, label: '8×8' },
        { id: 'c', w: 16, h: 20, x: 9, y: 0, label: '16×20' },
        { id: 'd', w: 8, h: 8, x: 26, y: 1.5, label: '8×8' },
        { id: 'e', w: 8, h: 8, x: 26, y: 10.5, label: '8×8' }
      ],
      bounds: { w: 34, h: 20 }
    }
  };

  var SCALE = 22;

  var stage = document.getElementById('CollageStage');
  var container = document.getElementById('CollageFrameContainer');
  var fileInput = document.getElementById('CollageFileInput');
  var addToCartButton = document.getElementById('CollageAddToCartButton');
  var variantSelect = document.querySelector('[data-collage-variant-select]');
  var toolbar = document.getElementById('CollageToolbar');
  var totalPriceEl = document.getElementById('CollageTotalPrice');
  var customizerEl = document.getElementById('CollageCustomizerInline');
  var addonsHandle = customizerEl ? customizerEl.getAttribute('data-collage-addons-handle') : null;
  var addonsProductData = null;
  var addonsLoaded = false;
  var isSubmitting = false;
  var productJsonEl = document.querySelector('script[id^="ProductJson-"]');
  var productData = null;
  var baseProductLoaded = false;
  var baseProductLoadPromise = null;
  try {
    productData = productJsonEl ? JSON.parse(productJsonEl.textContent || productJsonEl.innerText || '{}') : null;
  } catch (e) {
    productData = null;
  }

  function getBaseProductHandleFromLocation() {
    var path = window.location && window.location.pathname ? window.location.pathname : '';
    var m = path.match(/\/products\/([^\/]+)/);
    return m && m[1] ? m[1] : null;
  }

  function ensureBaseProductLoaded() {
    if (baseProductLoaded) return Promise.resolve(productData);
    if (baseProductLoadPromise) return baseProductLoadPromise;

    baseProductLoadPromise = new Promise(function (resolve) {
      // If we successfully parsed ProductJson and it has variants, we're good.
      if (productData && productData.variants && productData.variants.length) {
        baseProductLoaded = true;
        resolve(productData);
        return;
      }

      var handle = getBaseProductHandleFromLocation();
      if (!handle) {
        baseProductLoaded = true;
        resolve(productData);
        return;
      }

      fetch('/products/' + handle + '.js', {
        method: 'GET',
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Failed to load base product');
          return r.json();
        })
        .then(function (data) {
          productData = data;
          baseProductLoaded = true;
          resolve(productData);
          syncVariantAndPrice();
        })
        .catch(function () {
          baseProductLoaded = true;
          resolve(productData);
          syncVariantAndPrice();
        });
    });

    return baseProductLoadPromise;
  }

  var moneyFormat = (window.theme && window.theme.moneyFormat) || (window.Shopify && window.Shopify.money_format) || '${{amount}}';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    var n = (parseInt(cents, 10) || 0) / 100;
    return '$' + n.toFixed(2);
  }

  if (!container || !stage) return;

  var currentLayoutKey = 'option_1';
  var activeFrameId = null;
  var frameElements = {};
  var imageDataByFrameId = {};
  var imageTransforms = {};
  var isAddingToCart = false;

  /* ── Undo/Redo history ── */
  var undoStack = [];
  var redoStack = [];
  var MAX_UNDO = 40;

  /** Snapshots store image keys (frame IDs with images) but reference
   *  imageDataByFrameId for the actual base64 data to avoid duplicating
   *  multi-MB strings in every undo entry. We only store image data when
   *  the set of images changes (add/remove). */
  function pushUndo() {
    var snapshot = {};
    Object.keys(imageTransforms).forEach(function (id) {
      var t = imageTransforms[id];
      snapshot[id] = { rotate: t.rotate, scale: t.scale, x: t.x, y: t.y };
    });
    // Only store image data refs (frameId -> dataUrl) when images exist
    var imageRefs = {};
    Object.keys(imageDataByFrameId).forEach(function (id) {
      imageRefs[id] = imageDataByFrameId[id];
    });
    var entry = {
      transforms: snapshot,
      imageRefs: imageRefs,
      activeFrameId: activeFrameId
    };
    undoStack.push(entry);
    if (undoStack.length > MAX_UNDO) undoStack.shift();
    redoStack = [];
    updateUndoRedoButtons();
  }

  function captureCurrentSnapshot() {
    var snapshot = {
      transforms: {},
      imageRefs: {},
      activeFrameId: activeFrameId
    };
    Object.keys(imageTransforms).forEach(function (id) {
      var t = imageTransforms[id];
      snapshot.transforms[id] = { rotate: t.rotate, scale: t.scale, x: t.x, y: t.y };
    });
    Object.keys(imageDataByFrameId).forEach(function (id) {
      snapshot.imageRefs[id] = imageDataByFrameId[id];
    });
    return snapshot;
  }

  function applySnapshot(entry) {
    // Remove images not in snapshot
    Object.keys(imageDataByFrameId).forEach(function (id) {
      if (!entry.imageRefs[id]) {
        removeImageFromFrameSilent(id);
      }
    });
    // Restore images from snapshot
    Object.keys(entry.imageRefs).forEach(function (id) {
      if (imageDataByFrameId[id] !== entry.imageRefs[id]) {
        addImageToFrameSilent(id, entry.imageRefs[id]);
      }
    });
    // Restore transforms
    imageTransforms = {};
    Object.keys(entry.transforms).forEach(function (id) {
      var t = entry.transforms[id];
      imageTransforms[id] = { rotate: t.rotate, scale: t.scale, x: t.x, y: t.y };
      applyTransform(id);
    });
    // Clear images that have no data in the snapshot
    Object.keys(imageDataByFrameId).forEach(function (id) {
      if (!entry.imageRefs[id]) {
        delete imageDataByFrameId[id];
      }
    });
    activeFrameId = entry.activeFrameId;
    if (activeFrameId) {
      setActiveFrame(activeFrameId);
    } else {
      activeFrameId = null;
      updateToolbarVisibility();
    }
  }

  function undo() {
    if (undoStack.length === 0) return;
    redoStack.push(captureCurrentSnapshot());
    var entry = undoStack.pop();
    applySnapshot(entry);
    updateUndoRedoButtons();
  }

  function redo() {
    if (redoStack.length === 0) return;
    undoStack.push(captureCurrentSnapshot());
    var entry = redoStack.pop();
    applySnapshot(entry);
    updateUndoRedoButtons();
  }

  function updateUndoRedoButtons() {
    var undoBtn = document.getElementById('CollageToolUndo');
    var redoBtn = document.getElementById('CollageToolRedo');
    if (undoBtn) {
      undoBtn.disabled = undoStack.length === 0;
      undoBtn.style.opacity = undoStack.length === 0 ? '0.35' : '1';
    }
    if (redoBtn) {
      redoBtn.disabled = redoStack.length === 0;
      redoBtn.style.opacity = redoStack.length === 0 ? '0.35' : '1';
    }
  }

  function uid() {
    return 'cg_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
  }

  function renderLayout(layoutKey) {
    var layout = LAYOUTS[layoutKey];
    if (!layout) return;

    container.innerHTML = '';
    frameElements = {};

    // Use stage dimensions to calculate scale (minus padding)
    var stageWidth = stage.offsetWidth || 800;
    var stageHeight = stage.offsetHeight || 600;
    var padding = 100; // Space around the frame container
    
    var scale = Math.min(
      (stageWidth - padding * 2) / layout.bounds.w,
      (stageHeight - padding * 2) / layout.bounds.h
    );
    
    // Set container size to match scaled layout bounds
    var containerWidth = layout.bounds.w * scale;
    var containerHeight = layout.bounds.h * scale;
    container.style.width = containerWidth + 'px';
    container.style.height = containerHeight + 'px';

    // Frames positioned relative to container (0,0) - no offset needed
    // CSS flexbox on stage will center the container
    layout.frames.forEach(function (f) {
      var div = document.createElement('div');
      div.className = 'collage-frame';
      div.setAttribute('data-frame-id', f.id);
      div.style.left = (f.x * scale) + 'px';
      div.style.top = (f.y * scale) + 'px';
      div.style.width = (f.w * scale) + 'px';
      div.style.height = (f.h * scale) + 'px';

      var placeholder = document.createElement('div');
      placeholder.className = 'collage-frame__placeholder';
      placeholder.innerHTML = '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="margin-bottom:8px;opacity:0.5;"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg><div style="font-size:12px;">Drop image or click to upload</div><div style="font-size:11px;opacity:0.7;margin-top:2px;">' + f.label + '</div>';
      div.appendChild(placeholder);

      div.addEventListener('click', function (e) {
        e.stopPropagation();
        setActiveFrame(f.id);
        if (!imageDataByFrameId[f.id]) {
          fileInput.value = '';
          fileInput.click();
        }
      });

      // ── Drag-and-drop upload ──
      div.addEventListener('dragenter', function (e) {
        e.preventDefault();
        e.stopPropagation();
        div.classList.add('is-dragover');
      });
      div.addEventListener('dragover', function (e) {
        e.preventDefault();
        e.stopPropagation();
        div.classList.add('is-dragover');
      });
      div.addEventListener('dragleave', function (e) {
        e.preventDefault();
        e.stopPropagation();
        div.classList.remove('is-dragover');
      });
      div.addEventListener('drop', function (e) {
        e.preventDefault();
        e.stopPropagation();
        div.classList.remove('is-dragover');
        var files = e.dataTransfer && e.dataTransfer.files;
        if (!files || files.length === 0) return;
        var file = files[0];
        if (!file.type.match(/^image\//)) return;
        setActiveFrame(f.id);
        loadFileIntoFrame(f.id, file);
      });

      container.appendChild(div);
      frameElements[f.id] = div;
    });

    // Restore any existing images after re-render (e.g. resize)
    Object.keys(imageDataByFrameId).forEach(function (id) {
      if (frameElements[id] && imageDataByFrameId[id]) {
        addImageToFrameSilent(id, imageDataByFrameId[id]);
        if (imageTransforms[id]) {
          clampPan(id);
          applyTransform(id);
        }
      }
    });

    setActiveLayoutButton(layoutKey);
    activeFrameId = null;
    updateToolbarVisibility();
  }

  function setActiveFrame(frameId) {
    activeFrameId = frameId;

    Object.keys(frameElements).forEach(function (id) {
      frameElements[id].classList.toggle('is-active', id === frameId);
    });

    updateToolbarVisibility();
    updateZoomIndicator();
  }

  function updateToolbarVisibility() {
    if (!toolbar) return;
    var hasImage = activeFrameId && imageDataByFrameId[activeFrameId];
    if (hasImage) {
      toolbar.classList.remove('tw-hidden');
      toolbar.classList.add('tw-flex');
      requestAnimationFrame(function () {
        toolbar.classList.add('is-visible');
      });
    } else {
      toolbar.classList.remove('is-visible');
      // Delay hiding to allow fade-out animation
      setTimeout(function () {
        if (!toolbar.classList.contains('is-visible')) {
          toolbar.classList.add('tw-hidden');
          toolbar.classList.remove('tw-flex');
        }
      }, 200);
    }
    updateUndoRedoButtons();
    updateZoomIndicator();
  }

  function setActiveLayoutButton(layoutKey) {
    document.querySelectorAll('[data-collage-layout]').forEach(function (btn) {
      var isActive = btn.getAttribute('data-collage-layout') === layoutKey;
      btn.setAttribute('data-active', isActive ? 'true' : 'false');
    });
  }

  function getActiveLayoutLabel() {
    var activeBtn = document.querySelector('[data-collage-layout][data-active="true"]');
    var labelEl = activeBtn ? activeBtn.querySelector('span') : null;
    return labelEl ? labelEl.textContent.trim() : currentLayoutKey;
  }

  function getActiveVariantKey() {
    var activeBtn = document.querySelector('[data-collage-layout][data-active="true"]');
    return activeBtn ? activeBtn.getAttribute('data-variant-key') : null;
  }

  function getCheckedLabelText(inputName, fallback) {
    var input = document.querySelector('input[name="' + inputName + '"]:checked');
    var label = input ? input.closest('label') : null;
    var span = label ? label.querySelector('span') : null;
    return span ? span.textContent.trim() : fallback;
  }

  function getCheckedValue(inputName, fallback) {
    var input = document.querySelector('input[name="' + inputName + '"]:checked');
    return input ? String(input.value || '') : fallback;
  }

  function getCheckedValues(inputName) {
    var nodes = document.querySelectorAll('input[name="' + inputName + '"]:checked');
    var values = [];
    nodes.forEach(function (n) {
      values.push(String(n.value || ''));
    });
    return values;
  }

  function normalizeText(s) {
    return String(s || '').toLowerCase().trim();
  }

  function normalizeOptionValue(s) {
    return normalizeText(s).replace(/[\s\-_]+/g, '');
  }

  function loadAddonsProduct() {
    if (!addonsHandle) {
      addonsLoaded = true;
      return;
    }
    fetch('/products/' + addonsHandle + '.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Failed to load add-ons product');
        return r.json();
      })
      .then(function (data) {
        addonsProductData = data;
        addonsLoaded = true;
        syncVariantAndPrice();
      })
      .catch(function () {
        addonsLoaded = true;
        syncVariantAndPrice();
      });
  }

  function findAddonVariant(predicate) {
    if (!addonsProductData || !addonsProductData.variants) return null;
    for (var i = 0; i < addonsProductData.variants.length; i++) {
      var v = addonsProductData.variants[i];
      if (!v || v.available === false) continue;
      if (predicate(v)) return v;
    }
    return null;
  }

  function getAddonSelections() {
    var selections = [];

    var materialValue = getCheckedValue('collage_material', 'acrylic');
    var serviceValues = getCheckedValues('collage_service');

    if (materialValue === 'metal') {
      var metalVariant = findAddonVariant(function (v) {
        var t = normalizeText(v.title);
        return t.indexOf('metal') !== -1;
      });
      if (metalVariant) {
        selections.push({ id: metalVariant.id, price: metalVariant.price, key: 'metal' });
      } else {
        selections.push({ id: null, price: 1500, key: 'metal' });
      }
    }

    if (serviceValues.indexOf('touch_ups') !== -1) {
      var touchVariant = findAddonVariant(function (v) {
        var t = normalizeText(v.title);
        return t.indexOf('touch') !== -1;
      });
      if (touchVariant) {
        selections.push({ id: touchVariant.id, price: touchVariant.price, key: 'touch_ups' });
      } else {
        selections.push({ id: null, price: 500, key: 'touch_ups' });
      }
    }

    if (serviceValues.indexOf('adjustments') !== -1) {
      var adjVariant = findAddonVariant(function (v) {
        var t = normalizeText(v.title);
        return t.indexOf('adjust') !== -1;
      });
      if (adjVariant) {
        selections.push({ id: adjVariant.id, price: adjVariant.price, key: 'adjustments' });
      } else {
        selections.push({ id: null, price: 1000, key: 'adjustments' });
      }
    }

    return selections;
  }

  function findVariantById(id) {
    if (!productData || !productData.variants || !id) return null;
    var numericId = parseInt(id, 10);
    for (var i = 0; i < productData.variants.length; i++) {
      if (productData.variants[i].id === numericId) return productData.variants[i];
    }
    return null;
  }

  function getSelectedVariant() {
    if (!productData || !productData.variants) return null;

    var variantKey = getActiveVariantKey();
    var layoutLabel = getActiveLayoutLabel();

    var layoutValue = String(currentLayoutKey || '');
    var layoutTitleFromKey = null;
    var keyMatch = layoutValue.match(/^option_(\d+)$/);
    if (keyMatch && keyMatch[1]) {
      layoutTitleFromKey = 'Option ' + keyMatch[1];
    }
    var layoutCandidates = [variantKey, layoutLabel, layoutTitleFromKey, layoutValue].filter(Boolean);

    for (var c = 0; c < layoutCandidates.length; c++) {
      var selectedLayout = layoutCandidates[c];
      for (var i = 0; i < productData.variants.length; i++) {
        var v = productData.variants[i];
        var opt1 = v.option1 || v.options && v.options[0];
        if (!opt1) continue;
        if (normalizeOptionValue(opt1) === normalizeOptionValue(selectedLayout)) return v;
      }
    }

    return null;
  }

  function syncVariantAndPrice() {
    if (!baseProductLoaded) {
      ensureBaseProductLoaded();
    }

    var v = getSelectedVariant();
    if (v && variantSelect) {
      variantSelect.value = String(v.id);
    }

    var addons = getAddonSelections();
    var unresolvedAddons = addons.some(function (a) {
      return a.id === null;
    });

    if (addToCartButton && !isSubmitting) {
      var requiresResolvedAddons = addons.length > 0;
      var canAdd = !!v && (!requiresResolvedAddons || (addonsLoaded && !unresolvedAddons));
      addToCartButton.disabled = !canAdd;
      addToCartButton.setAttribute('aria-disabled', canAdd ? 'false' : 'true');
    }

    var cartPriceEl = document.getElementById('CollageCartPrice');
    if (totalPriceEl || cartPriceEl) {
      if (!v) {
        if (totalPriceEl) totalPriceEl.textContent = '—';
        if (cartPriceEl) cartPriceEl.textContent = '';
      } else {
        var addonTotal = 0;
        addons.forEach(function (a) {
          addonTotal += parseInt(a.price, 10) || 0;
        });
        var formattedTotal = formatMoney((parseInt(v.price, 10) || 0) + addonTotal);
        if (totalPriceEl) totalPriceEl.textContent = formattedTotal;
        if (cartPriceEl) cartPriceEl.textContent = formattedTotal;
      }
    }
  }

  function addImageToFrame(frameId, dataUrl) {
    pushUndo();
    // Reset transforms for new/replaced images so they start fresh
    imageTransforms[frameId] = { rotate: 0, scale: 1, x: 0, y: 0 };
    addImageToFrameSilent(frameId, dataUrl);
  }

  /** Add image without pushing undo (used by undo/redo restore and resize re-render) */
  function addImageToFrameSilent(frameId, dataUrl) {
    var frameEl = frameElements[frameId];
    if (!frameEl) return;

    imageDataByFrameId[frameId] = dataUrl;
    if (!imageTransforms[frameId]) {
      imageTransforms[frameId] = { rotate: 0, scale: 1, x: 0, y: 0 };
    }

    var placeholder = frameEl.querySelector('.collage-frame__placeholder');
    if (placeholder) placeholder.style.display = 'none';

    var existingImg = frameEl.querySelector('.collage-frame__image');
    if (existingImg) existingImg.remove();

    var img = document.createElement('img');
    img.className = 'collage-frame__image';
    img.src = dataUrl;
    img.draggable = false;
    frameEl.appendChild(img);

    setupImageDrag(frameId, img);
    applyTransform(frameId);
    updateToolbarVisibility();
  }

  /* ── Centralized drag handling ──
   * Instead of attaching document-level listeners per-image (which accumulate
   * on resize re-renders), we use a single set of document-level listeners
   * and track the currently-dragging image via closure variables. */
  var dragState = null; // { frameId, img, startX, startY, startTX, startTY, moved }

  function onGlobalPointerMove(e) {
    if (!dragState) return;
    if (e.touches) e.preventDefault();
    var pt = e.touches ? e.touches[0] : e;
    var dx = pt.clientX - dragState.startX;
    var dy = pt.clientY - dragState.startY;
    if (Math.abs(dx) > 2 || Math.abs(dy) > 2) dragState.moved = true;

    var newX = dragState.startTX + dx;
    var newY = dragState.startTY + dy;

    // ── Drag boundary constraints ──
    var frameEl = frameElements[dragState.frameId];
    if (frameEl) {
      var fw = frameEl.offsetWidth;
      var fh = frameEl.offsetHeight;
      var t = imageTransforms[dragState.frameId];
      if (!t) { cleanupDrag(); return; }
      var s = t.scale || 1;
      var isRotated90 = (Math.abs(t.rotate % 180) === 90);
      var imgW = isRotated90 ? fh * s : fw * s;
      var imgH = isRotated90 ? fw * s : fh * s;
      var maxPanX = Math.max(0, (imgW - fw) / 2);
      var maxPanY = Math.max(0, (imgH - fh) / 2);
      newX = Math.max(-maxPanX, Math.min(maxPanX, newX));
      newY = Math.max(-maxPanY, Math.min(maxPanY, newY));
    }

    if (!imageTransforms[dragState.frameId]) { cleanupDrag(); return; }
    imageTransforms[dragState.frameId].x = newX;
    imageTransforms[dragState.frameId].y = newY;
    applyTransform(dragState.frameId);
  }

  function cleanupDrag() {
    if (!dragState) return;
    // If the user didn't actually drag, discard the no-op undo entry and restore redo stack
    if (!dragState.moved && undoStack.length > 0) {
      undoStack.pop();
      redoStack = dragState.savedRedo;
      updateUndoRedoButtons();
    }
    dragState.img.style.cursor = '';
    dragState = null;
  }

  function onGlobalPointerUp() {
    cleanupDrag();
  }

  // Single set of document-level listeners (never duplicated)
  document.addEventListener('mousemove', onGlobalPointerMove);
  document.addEventListener('mouseup', onGlobalPointerUp);
  document.addEventListener('touchmove', onGlobalPointerMove, { passive: false });
  document.addEventListener('touchend', onGlobalPointerUp);

  function setupImageDrag(frameId, img) {
    function onPointerDown(e) {
      if (!imageTransforms[frameId]) return;
      e.preventDefault();
      e.stopPropagation();
      // Snapshot BEFORE the drag begins so undo restores pre-drag state
      var savedRedo = redoStack.slice();
      pushUndo();
      var pt = e.touches ? e.touches[0] : e;
      dragState = {
        frameId: frameId,
        img: img,
        startX: pt.clientX,
        startY: pt.clientY,
        startTX: imageTransforms[frameId].x,
        startTY: imageTransforms[frameId].y,
        moved: false,
        savedRedo: savedRedo
      };
      img.style.cursor = 'grabbing';
    }

    img.addEventListener('mousedown', onPointerDown);
    img.addEventListener('touchstart', onPointerDown, { passive: false });
  }

  function applyTransform(frameId) {
    var frameEl = frameElements[frameId];
    var img = frameEl?.querySelector('.collage-frame__image');
    var t = imageTransforms[frameId];
    if (!img || !t) return;
    var x = Math.round(t.x * 2) / 2;
    var y = Math.round(t.y * 2) / 2;
    img.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, 0) rotate(' + t.rotate + 'deg) scale(' + t.scale + ')';
  }

  function rotateImage(delta) {
    if (!activeFrameId || !imageTransforms[activeFrameId]) return;
    pushUndo();
    imageTransforms[activeFrameId].rotate += delta;
    applyTransform(activeFrameId);
    autoFitAfterRotation(activeFrameId);
  }

  /** After rotation, auto-zoom to ensure the image fills the frame with no gaps */
  function autoFitAfterRotation(frameId) {
    var frameEl = frameElements[frameId];
    var t = imageTransforms[frameId];
    if (!frameEl || !t) return;
    var fw = frameEl.offsetWidth;
    var fh = frameEl.offsetHeight;
    var isRotated90 = (Math.abs(t.rotate % 180) === 90);
    // When rotated 90/270, the image's effective dimensions swap
    var minScale;
    if (isRotated90) {
      minScale = Math.max(fw / fh, fh / fw);
    } else {
      minScale = 1;
    }
    if (t.scale < minScale) {
      t.scale = minScale;
    }
    // Clamp pan so image still covers the frame
    clampPan(frameId);
    applyTransform(frameId);
    updateZoomIndicator();
  }

  /** Clamp pan position so image can't be dragged off the frame */
  function clampPan(frameId) {
    var frameEl = frameElements[frameId];
    var t = imageTransforms[frameId];
    if (!frameEl || !t) return;
    var fw = frameEl.offsetWidth;
    var fh = frameEl.offsetHeight;
    var s = t.scale || 1;
    var isRotated90 = (Math.abs(t.rotate % 180) === 90);
    var imgW = isRotated90 ? fh * s : fw * s;
    var imgH = isRotated90 ? fw * s : fh * s;
    var maxPanX = Math.max(0, (imgW - fw) / 2);
    var maxPanY = Math.max(0, (imgH - fh) / 2);
    t.x = Math.max(-maxPanX, Math.min(maxPanX, t.x));
    t.y = Math.max(-maxPanY, Math.min(maxPanY, t.y));
  }

  function zoomImage(factor) {
    if (!activeFrameId || !imageTransforms[activeFrameId]) return;
    pushUndo();
    var t = imageTransforms[activeFrameId];
    var frameEl = frameElements[activeFrameId];
    var isRotated90 = (Math.abs(t.rotate % 180) === 90);
    var minScale = 0.5;
    if (isRotated90 && frameEl) {
      var fw = frameEl.offsetWidth;
      var fh = frameEl.offsetHeight;
      minScale = Math.max(minScale, Math.max(fw / fh, fh / fw));
    }
    t.scale = Math.max(minScale, Math.min(3, t.scale * factor));
    clampPan(activeFrameId);
    applyTransform(activeFrameId);
    updateZoomIndicator();
  }

  function resetZoom() {
    if (!activeFrameId || !imageTransforms[activeFrameId]) return;
    pushUndo();
    var t = imageTransforms[activeFrameId];
    t.scale = 1;
    t.x = 0;
    t.y = 0;
    // If rotated, ensure still fits
    autoFitAfterRotation(activeFrameId);
    applyTransform(activeFrameId);
    updateZoomIndicator();
  }

  function updateZoomIndicator() {
    var indicator = document.getElementById('CollageZoomIndicator');
    if (!indicator) return;
    if (activeFrameId && imageTransforms[activeFrameId]) {
      var pct = Math.round(imageTransforms[activeFrameId].scale * 100);
      var span = indicator.querySelector('span') || indicator;
      span.textContent = pct + '%';
      indicator.style.display = '';
    } else {
      indicator.style.display = 'none';
    }
  }

  function removeImageFromFrame(frameId) {
    pushUndo();
    removeImageFromFrameSilent(frameId);
  }

  /** Remove image without pushing undo (used by undo/redo restore) */
  function removeImageFromFrameSilent(frameId) {
    var frameEl = frameElements[frameId];
    if (!frameEl) return;

    delete imageDataByFrameId[frameId];
    delete imageTransforms[frameId];

    var img = frameEl.querySelector('.collage-frame__image');
    if (img) img.remove();

    var placeholder = frameEl.querySelector('.collage-frame__placeholder');
    if (placeholder) placeholder.style.display = '';

    updateToolbarVisibility();
  }

  /** Load a file into a frame with loading state */
  function loadFileIntoFrame(frameId, file) {
    var frameEl = frameElements[frameId];
    if (!frameEl) return;

    // Show loading shimmer
    var placeholder = frameEl.querySelector('.collage-frame__placeholder');
    if (placeholder) placeholder.style.display = 'none';
    var existingImg = frameEl.querySelector('.collage-frame__image');
    if (existingImg) existingImg.remove();

    var shimmer = document.createElement('div');
    shimmer.className = 'collage-frame__shimmer';
    frameEl.appendChild(shimmer);

    var reader = new FileReader();
    reader.onload = function (ev) {
      var s = frameEl.querySelector('.collage-frame__shimmer');
      if (s) s.remove();
      addImageToFrame(frameId, ev.target.result);
    };
    reader.onerror = function () {
      var s = frameEl.querySelector('.collage-frame__shimmer');
      if (s) s.remove();
      // Clean up stale data since the old img was already removed from the DOM
      delete imageDataByFrameId[frameId];
      delete imageTransforms[frameId];
      if (placeholder) placeholder.style.display = '';
      updateToolbarVisibility();
    };
    reader.readAsDataURL(file);
  }

  function serializeDesign() {
    var layout = LAYOUTS[currentLayoutKey];
    var frames = layout.frames.map(function (f) {
      var t = imageTransforms[f.id] || { rotate: 0, scale: 1, x: 0, y: 0 };
      return {
        id: f.id,
        hasImage: !!imageDataByFrameId[f.id],
        rotate: t.rotate,
        scale: t.scale,
        x: t.x,
        y: t.y
      };
    });

    var material = document.querySelector('input[name="collage_material"]:checked');
    var services = getCheckedValues('collage_service');

    return {
      designId: uid(),
      layout: currentLayoutKey,
      material: material ? material.value : 'acrylic',
      services: services,
      frames: frames
    };
  }

  /** Prettify a raw value: "touch_ups" → "Touch ups", "acrylic" → "Acrylic" */
  function prettify(s) {
    var str = String(s || '').replace(/_/g, ' ').trim();
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  /** Get human-readable layout name from the active sidebar button */
  function getLayoutDisplayName() {
    var activeBtn = document.querySelector('[data-collage-layout][data-active="true"]');
    var span = activeBtn ? activeBtn.querySelector('span') : null;
    return span ? span.textContent.trim() : prettify(currentLayoutKey);
  }

  /** Get human-readable material name from checked radio label */
  function getMaterialDisplayName() {
    var input = document.querySelector('input[name="collage_material"]:checked');
    if (!input) return 'Acrylic';
    var label = input.closest('label');
    var span = label ? label.querySelector('span') : null;
    return span ? span.textContent.trim() : prettify(input.value);
  }

  /** Get human-readable services list from checked checkboxes */
  function getServicesDisplayList() {
    var nodes = document.querySelectorAll('input[name="collage_service"]:checked');
    var names = [];
    nodes.forEach(function (input) {
      var label = input.closest('label');
      var span = label ? label.querySelector('span') : null;
      names.push(span ? span.textContent.trim() : prettify(input.value));
    });
    return names;
  }

  /** Capture a JPEG thumbnail of the collage stage via modern-screenshot */
  function captureStageSnapshot() {
    if (!window.modernScreenshot || !container) return Promise.resolve(null);

    // Temporarily remove active-frame highlight so it doesn't appear in the thumbnail
    var prevActive = activeFrameId;
    Object.keys(frameElements).forEach(function (id) {
      frameElements[id].classList.remove('is-active');
    });

    return window.modernScreenshot.domToJpeg(container, {
      quality: 0.6,
      scale: 0.35,
      backgroundColor: '#ffffff'
    })
      .then(function (dataUrl) {
        // Restore active-frame highlight
        if (prevActive && frameElements[prevActive]) {
          frameElements[prevActive].classList.add('is-active');
        }
        return dataUrl || null;
      })
      .catch(function () {
        // Restore active-frame highlight on error
        if (prevActive && frameElements[prevActive]) {
          frameElements[prevActive].classList.add('is-active');
        }
        return null;
      });
  }

  /** Show a brief "Added to cart" toast, then redirect */
  function showAddToCartToast(callback) {
    var existing = document.getElementById('CollageAddToCartToast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.id = 'CollageAddToCartToast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.style.cssText =
      'position:fixed;top:24px;right:24px;z-index:10000;' +
      'display:flex;align-items:center;gap:12px;' +
      'background:#fff;border:1px solid rgba(90,70,50,0.18);' +
      'border-radius:12px;padding:14px 22px;' +
      'box-shadow:0 8px 32px rgba(42,36,30,0.16);' +
      'font-family:Inter,system-ui,sans-serif;font-size:15px;color:#2a241e;' +
      'transform:translateX(120%);transition:transform 0.35s cubic-bezier(0.22,1,0.36,1),opacity 0.35s ease;opacity:0;';

    toast.innerHTML =
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#8a5a3c" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M20 6L9 17l-5-5"/>' +
      '</svg>' +
      '<span style="font-weight:500;">Added to cart</span>';

    document.body.appendChild(toast);

    // Slide in
    requestAnimationFrame(function () {
      toast.style.transform = 'translateX(0)';
      toast.style.opacity = '1';
    });

    // Slide out after delay, then redirect
    setTimeout(function () {
      toast.style.transform = 'translateX(120%)';
      toast.style.opacity = '0';
      setTimeout(function () {
        toast.remove();
        if (callback) callback();
      }, 350);
    }, 1500);
  }

  function addToCart() {
    if (isSubmitting) return;

    if (!variantSelect) {
      alert('Variant selector not found.');
      return;
    }

    var variantId = variantSelect.value;
    if (!variantId) {
      alert('No variant selected.');
      return;
    }

    var design = serializeDesign();

    var addons = getAddonSelections();
    var unresolvedAddons = addons.some(function (a) {
      return a.id === null;
    });
    if (addons.length > 0 && (!addonsLoaded || unresolvedAddons)) {
      alert('Please wait—loading add-ons pricing.');
      return;
    }

    // Hidden properties for internal use
    var properties = {
      _collage_design_id: design.designId,
      _collage_layout: design.layout,
      _collage_material: design.material,
      _collage_services: (design.services || []).join(', '),
      _collage_design_json: JSON.stringify(design)
    };

    // Visible properties displayed in cart (no underscore prefix)
    properties['Layout'] = getLayoutDisplayName();
    properties['Material'] = getMaterialDisplayName();
    var serviceNames = getServicesDisplayList();
    if (serviceNames.length > 0) {
      properties['Services'] = serviceNames.join(', ');
    }

    var addonProperties = {
      _collage_design_id: design.designId
    };

    // Disable button to prevent double-clicks
    isSubmitting = true;
    if (addToCartButton) {
      addToCartButton.disabled = true;
      addToCartButton.setAttribute('aria-disabled', 'true');
    }

    // Capture stage snapshot, then submit cart
    captureStageSnapshot().then(function (snapshotDataUrl) {
      // Only attach if within Shopify's line item property size budget
      if (snapshotDataUrl && snapshotDataUrl.length <= 200000) {
        properties['_mczr_image'] = snapshotDataUrl;
      }

      var items = [{ id: parseInt(variantId, 10), quantity: 1, properties: properties }];
      addons.forEach(function (a) {
        items.push({ id: parseInt(a.id, 10), quantity: 1, properties: addonProperties });
      });

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function () {
        // Fire Meta Pixel AddToCart event
        if (typeof window.__meta_pixel_addToCart === 'function') {
          var variant = getSelectedVariant();
          var addons = getAddonSelections();
          var addonTotal = 0;
          addons.forEach(function (a) { addonTotal += parseInt(a.price, 10) || 0; });
          var totalCents = (parseInt(variant ? variant.price : 0, 10) || 0) + addonTotal;
          window.__meta_pixel_addToCart({
            content_name: 'Custom Gridscape — ' + getLayoutDisplayName() + ' / ' + getMaterialDisplayName(),
            content_ids: [variant ? String(variant.id) : ''],
            value: totalCents / 100,
            currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'USD'
          });
        }

        // Keep isSubmitting true — page will redirect after toast
        showAddToCartToast(function () {
          window.location.href = '/cart';
        });
      })
      .catch(function (err) {
        isSubmitting = false;
        // Re-sync button state via variant/price logic instead of blindly
        // re-enabling — avoids stale-variant submission if layout changed
        // while the async chain was in-flight.
        syncVariantAndPrice();
        alert(err.message || 'Add to cart failed');
      });
  }

  // ── Layout switch with confirmation ──
  document.querySelectorAll('[data-collage-layout]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var next = btn.getAttribute('data-collage-layout');
      if (!next || next === currentLayoutKey) return;

      var hasImages = Object.keys(imageDataByFrameId).length > 0;
      if (hasImages) {
        showConfirmDialog(
          'Change layout?',
          'Switching layouts will clear your uploaded photos.',
          function () {
            currentLayoutKey = next;
            setActiveLayoutButton(currentLayoutKey);
            imageDataByFrameId = {};
            imageTransforms = {};
            undoStack = [];
            redoStack = [];
            renderLayout(currentLayoutKey);
            syncVariantAndPrice();
          }
        );
      } else {
        currentLayoutKey = next;
        setActiveLayoutButton(currentLayoutKey);
        imageDataByFrameId = {};
        imageTransforms = {};
        undoStack = [];
        redoStack = [];
        renderLayout(currentLayoutKey);
        syncVariantAndPrice();
      }
    });
  });

  function showConfirmDialog(title, message, onConfirm) {
    // Remove any existing dialog
    var existing = document.getElementById('CollageConfirmDialog');
    if (existing) existing.remove();

    var overlay = document.createElement('div');
    overlay.id = 'CollageConfirmDialog';
    overlay.className = 'collage-confirm-overlay';
    overlay.innerHTML =
      '<div class="collage-confirm-dialog">' +
        '<div class="collage-confirm-title">' + title + '</div>' +
        '<div class="collage-confirm-message">' + message + '</div>' +
        '<div class="collage-confirm-actions">' +
          '<button type="button" class="collage-confirm-btn collage-confirm-btn--cancel">Cancel</button>' +
          '<button type="button" class="collage-confirm-btn collage-confirm-btn--confirm">Continue</button>' +
        '</div>' +
      '</div>';

    var cancelBtn = overlay.querySelector('.collage-confirm-btn--cancel');
    var confirmBtn = overlay.querySelector('.collage-confirm-btn--confirm');

    function close() {
      overlay.classList.remove('is-visible');
      setTimeout(function () { overlay.remove(); }, 200);
    }

    cancelBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    confirmBtn.addEventListener('click', function () {
      close();
      onConfirm();
    });

    customizerEl.appendChild(overlay);
    requestAnimationFrame(function () {
      overlay.classList.add('is-visible');
    });
  }

  document.querySelectorAll('input[name="collage_material"], input[name="collage_service"]').forEach(function (input) {
    input.addEventListener('change', function () {
      syncNoneButtonState();
      syncVariantAndPrice();
    });
  });

  function syncNoneButtonState() {
    var clearBtn = document.querySelector('[data-collage-service-clear]');
    if (!clearBtn) return;
    var anyChecked = document.querySelectorAll('input[name="collage_service"]:checked').length > 0;
    clearBtn.classList.toggle('is-active', !anyChecked);
  }

  var clearServicesBtn = document.querySelector('[data-collage-service-clear]');
  if (clearServicesBtn) {
    clearServicesBtn.addEventListener('click', function () {
      document.querySelectorAll('input[name="collage_service"]').forEach(function (input) {
        input.checked = false;
      });
      syncNoneButtonState();
      syncVariantAndPrice();
    });
  }

  if (fileInput) {
    fileInput.addEventListener('change', function (e) {
      var file = e.target.files && e.target.files[0];
      if (!file || !activeFrameId) return;
      loadFileIntoFrame(activeFrameId, file);
    });
  }

  document.getElementById('CollageToolRotateLeft')?.addEventListener('click', function () {
    rotateImage(-90);
  });

  document.getElementById('CollageToolRotateRight')?.addEventListener('click', function () {
    rotateImage(90);
  });

  document.getElementById('CollageToolZoomIn')?.addEventListener('click', function () {
    zoomImage(1.15);
  });

  document.getElementById('CollageToolZoomOut')?.addEventListener('click', function () {
    zoomImage(1 / 1.15);
  });

  document.getElementById('CollageToolReplace')?.addEventListener('click', function () {
    if (!activeFrameId) return;
    fileInput.value = '';
    fileInput.click();
  });

  document.getElementById('CollageToolRemove')?.addEventListener('click', function () {
    if (!activeFrameId) return;
    removeImageFromFrame(activeFrameId);
  });

  // Zoom indicator reset
  document.getElementById('CollageZoomIndicator')?.addEventListener('click', function () {
    resetZoom();
  });

  // Undo / Redo
  document.getElementById('CollageToolUndo')?.addEventListener('click', function () {
    undo();
  });
  document.getElementById('CollageToolRedo')?.addEventListener('click', function () {
    redo();
  });

  // ── Deselect on click-away ──
  stage.addEventListener('click', function (e) {
    // Only deselect if clicking directly on stage or frame container background
    if (e.target === stage || e.target === container) {
      activeFrameId = null;
      Object.keys(frameElements).forEach(function (id) {
        frameElements[id].classList.remove('is-active');
      });
      updateToolbarVisibility();
    }
  });

  // Keyboard shortcut for undo/redo
  document.addEventListener('keydown', function (e) {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'z') {
      e.preventDefault();
      // Block undo/redo while a drag is in progress to prevent state corruption
      if (dragState) return;
      if (e.shiftKey) {
        redo();
      } else {
        undo();
      }
    }
  });

  if (addToCartButton) {
    addToCartButton.addEventListener('click', addToCart);
  }

  // Wait for layout to be ready before rendering
  requestAnimationFrame(function() {
    renderLayout(currentLayoutKey);
    loadAddonsProduct();
    syncNoneButtonState();
    ensureBaseProductLoaded().then(function () {
      syncVariantAndPrice();
    });
  });
  
  // Re-render on window resize to maintain centering
  window.addEventListener('resize', function() {
    renderLayout(currentLayoutKey);
    syncVariantAndPrice();
  });

  // Initialize undo/redo button states
  updateUndoRedoButtons();
})();
